import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { ChartBarIcon, PlusIcon } from '@heroicons/react/24/outline';
import { api } from '../../services/api';

const Exercises: React.FC = () => {
  const { data: exercisesData, isLoading } = useQuery({
    queryKey: ['exercises'],
    queryFn: () => api.get('/exercises'),
  });

  const exercises = exercisesData?.data?.exercises || [];

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Exercises</h1>
          <p className="text-gray-600">Browse the exercise library</p>
        </div>
        <div className="mt-4 sm:mt-0">
          <button className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700">
            <PlusIcon className="h-5 w-5 mr-2" />
            Add Exercise
          </button>
        </div>
      </div>

      <div className="bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          {exercises.length > 0 ? (
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {exercises.map((exercise: any) => (
                <div
                  key={exercise.id}
                  className="bg-gray-50 rounded-lg p-4 hover:shadow-md transition-shadow"
                >
                  <div className="flex items-center">
                    <ChartBarIcon className="h-8 w-8 text-blue-500 mr-3" />
                    <div>
                      <h3 className="text-lg font-medium text-gray-900">
                        {exercise.name}
                      </h3>
                      <p className="text-sm text-gray-500">
                        {exercise.category} • {exercise.difficulty}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-12">
              <ChartBarIcon className="mx-auto h-12 w-12 text-gray-400" />
              <h3 className="mt-2 text-sm font-medium text-gray-900">No exercises</h3>
              <p className="mt-1 text-sm text-gray-500">
                Get started by adding exercises to the library.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Exercises;
